import { PropsWithChildren, useEffect } from "react";

import { useSession } from "@/shared/model/session";
import { useSystemInvalidation } from "@/shared/websocket/use-system-invalidation";
import { websocketClient } from "@/shared/websocket/websocket-client";

export function WebSocketProvider({ children }: PropsWithChildren) {
  const { isAuthenticated } = useSession();

  useEffect(() => {
    if (isAuthenticated) {
      websocketClient.connect();
    }

    return () => {
      if (isAuthenticated) {
        websocketClient.disconnect();
      }
    };
  }, [isAuthenticated]);

  useSystemInvalidation();

  return <>{children}</>;
}
